import router from './router'
import store from './store'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css'// Progress 进度条样式
import {Message} from 'element-ui'
import {getToken} from '@/utils/auth' // 验权
import versionTood from '@/utils/versionUpdate.js'
import {clearScrollPositions, getNavigationSource, saveScrollPosition} from '@/utils/pageNavigation'
import { updateBreadcrumbParent } from "@/utils/breadcrumb";
import { applyLatestLanguage } from '@/lang'
import { syncRouteTitles } from "@/utils/settingRouteLang";

const whiteList = ['/login', '/forgotPwd'] // 不重定向白名单

router.beforeEach((to, from, next) => {
  const languageSync = applyLatestLanguage()
  if (languageSync.changed) {
    syncRouteTitles(languageSync.previousLanguage, languageSync.language)
  }

  if (to.path === '/login') {
    clearScrollPositions()
    store.commit('RESET_PAGE_CACHE')
  }

  const breadcrumbParent = store.getters.breadcrumbParent
  const isDetailReturn = Boolean(from.meta && from.meta.detailPage && (
    from.meta.defaultParentName === to.name ||
    (breadcrumbParent && breadcrumbParent.detailRouteName === from.name && breadcrumbParent.name === to.name)
  ))
  const navigationSource = getNavigationSource()

  if (navigationSource === 'menu' && from.name && from.name !== to.name && from.meta && from.meta.keepAlive) {
    store.commit('RESET_PAGE_CACHE', from.name)
  } else if (navigationSource !== 'menu' && to.name && to.name !== from.name && to.meta && to.meta.keepAlive && !isDetailReturn) {
    store.commit('RESET_PAGE_CACHE', to.name)
  }

  if (from.name && from.meta && from.meta.keepAlive) {
    saveScrollPosition(from.name)
  }
  updateBreadcrumbParent(to, from)

  // if(process.env.NODE_ENV === "production") {
  //   versionTood.isNewVersion();
  // }
  NProgress.start()

  if (getToken()) {
    if (to.path === '/login') {
      next({path: '/'})
      NProgress.done() // if current page is dashboard will not trigger	afterEach hook, so manually handle it
    } else {
      if (store.getters.roles.length === 0) {
        store.dispatch('GetInfo').then(res => { // 拉取用户信息
          let menus = res.data.permission.menus;
          let username = res.data.username;
          store.dispatch('GenerateRoutes', {menus, username}).then(() => { // 生成可访问的路由表
            router.addRoutes(store.getters.addRouters); // 动态添加可访问路由表
            next({...to, replace: true})
            NProgress.done()
          })
        }).catch((err) => {
          store.dispatch('LogOut').then(() => {
            Message.error(err || 'Verification failed, please login again')
            next({path: '/login'})
          })
          NProgress.done()
        })
      } else {
        next()
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next('/login')
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done() // 结束Progress
})



// WEBPACK FOOTER //
// ./src/permission.js